import React from 'react';
import KBTreeSidebar from './KBTreeSidebar';

/**
 * Shared two-pane layout for any /kb/* page.
 *
 * - Tree sidebar on the left (always visible on lg+, collapses above the
 *   content on small screens).
 * - Content area on the right where the actual page (list / article /
 *   editor) is rendered as `children`.
 *
 * `refreshKey` lets pages that mutate articles (create/edit/delete)
 * bump the tree without forcing a hard reload.
 */
interface Props {
  children: React.ReactNode;
  refreshKey?: number;
}

const KBLayout: React.FC<Props> = ({ children, refreshKey }) => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 items-start">
      <KBTreeSidebar refreshKey={refreshKey} />
      <div className="flex-1 min-w-0 w-full">
        {children}
      </div>
    </div>
  );
};

export default KBLayout;
